import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Button } from './ui/button';

export default class ErrorBoundary extends React.Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidUpdate(prev) { if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null }); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" data-testid="error-boundary" className="max-w-xl mx-auto my-20 px-5 text-center">
        <div className="h-14 w-14 mx-auto rounded-2xl flex items-center justify-center" style={{ background: '#fff4d6' }}><AlertTriangle className="h-7 w-7 text-amber-600" /></div>
        <h2 className="mt-5 text-2xl font-extrabold" style={{ color: '#1a3a5c' }}>Da ist etwas schiefgelaufen</h2>
        <p className="mt-2 text-slate-600">Bitte lade die Seite neu oder kehre zur Startseite zurück.</p>
        <div className="mt-6 flex justify-center gap-3">
          <Button onClick={() => window.location.reload()} className="btn-teal rounded-full h-11 px-6">Neu laden</Button>
          <Link to="/"><Button variant="outline" className="btn-outline-teal rounded-full h-11 px-6">Zur Startseite</Button></Link>
        </div>
      </div>
    );
  }
}
